var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialIcon6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.243,
    height: 12.57,
    viewBox: "0 0 13.243 12.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_27569",
    "data-name": "Path 27569",
    d: "M1.013,5.268H12.231v6.29H1.013Zm9.139-2.454v-.9h2.079V4.256H1.013V1.913H3.155v.9H4.167v-.9H9.139v.9ZM9.139,0V.9H4.167V0H3.155V.9H0V12.57H13.243V.9H10.151V0Z",
    fill: "#152c40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon6);
export default __webpack_public_path__ + "static/media/social-icon6.c91c6fd4743ae652fd00968f4c17009a.svg";
export { ForwardRef as ReactComponent };